import { Component, Input, OnInit } from '@angular/core';
import * as shape from 'd3-shape';
import { Subject } from 'rxjs';

@Component({
  selector: 'lifedi-skill-tree',
  templateUrl: './skill-tree.component.html',
  styleUrls: ['./skill-tree.component.scss']
})
export class SkillTreeComponent implements OnInit {
  @Input() nodes: [];
  @Input() links: [];
  @Input() clusters: [];

  hierarchialGraph = { nodes: [], links: [], clusters: [] }

  update$: Subject<boolean> = new Subject();
  center$: Subject<boolean> = new Subject();
  zoomToFit$: Subject<boolean> = new Subject();
  curve = shape.curveBundle.beta(1);
  layoutSetting = {
    orientation: 'LR',
    edgePadding: 15,
    rankPadding: 50,
    nodePadding: 50,
    multigraph: true,
    compound: true,
    align: 'UL'
  }

  constructor() {
    this.center$.next(true);
    this.zoomToFit$.next(true);
  }

  ngOnInit(): void {
    this.center$.next(true);
    this.zoomToFit$.next(true);
  }

  openCourse(n) {
    // // console.log(n);
    if (n.id.length === 11) {
      window.open('/e-learning/' + n.id, '_blank');
    }
  }
}
